import type { participation as en } from '@/i18n/locales/en/participation';
import type { Translation } from '@/i18n/types';

export const participation: Translation<typeof en> = {
  page: {
    title: 'Participación',
    lead: 'El embudo de participación: de invitado a estructuralmente activo, más las tasas de participación diarias.',
    noScope: 'Selecciona una empresa para ver sus cifras de participación.',
    noDepartments: 'Ningún departamento aquí tiene estadísticas que puedas ver.',
    disclaimer:
      'Todas las cifras son indicadores orientativos de bienestar y no constituyen un diagnóstico médico. Las tendencias solo se muestran cuando hay suficientes participantes (privacidad desde el diseño).',
  },
  filters: {
    department: {
      label: 'Departamento',
    },
    location: {
      label: 'Ubicación',
      all: 'Todas las ubicaciones',
    },
  },
  funnel: {
    title: 'Embudo de participación',
    pctOfPrevious: '{{pct}}% del paso anterior',
    steps: {
      invited: 'Invitados',
      activated: 'Activados',
      active_7d: 'Activos (7d)',
      active_30d: 'Activos (30d)',
      structurally_active: 'Estructuralmente activos',
      needs_reactivation: 'A reactivar',
    },
  },
  rates: {
    title: 'Tasas de participación',
    keys: {
      daily_sync_pct: 'Sincronización diaria',
      ai_coach_use_pct: 'Uso del coach de IA',
      challenge_participation_pct: 'Participación en retos',
      notification_open_pct: 'Aperturas de notificaciones',
      break_adoption_pct: 'Adopción de pausas',
      focus_rhythm_pct: 'Ritmo de concentración',
    },
  },
  breakdown: {
    department: 'Por departamento',
    location: 'Por ubicación',
    pilotGroup: 'Por grupo piloto',
    empty: 'Aún no hay datos para desglosar.',
    pilotGroupEmpty: 'Ningún piloto cubre todavía este departamento.',
    ratio: '{{activated}}/{{invited}} · {{pct}}%',
    shielded: {
      badge: 'Protegido',
      message:
        'No hay suficientes participantes ({{invited}}) para una vista segura para la privacidad — se requieren al menos {{min}}.',
    },
    columns: {
      name: 'Nombre',
      invited: 'Invitados',
      activated: 'Activados',
      active30d: 'Activos (30d)',
    },
  },
  status: {
    noData: '—',
  },
};
